/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var o;!function(o){o[o.ColorAlpha=0]="ColorAlpha",o[o.FrontFace=1]="FrontFace",o[o.NONE=2]="NONE",o[o.COUNT=3]="COUNT"}(o||(o={}));export{o as TransparencyPassType};
